<template>
  <div class="rate-container">
    <div class="rate-table-container">
      <div class="header">
        <div class="title">{{ $t(`${i18nPrefix}.title.rateManagement`) }}</div>
        <div class="search">
          <el-input
            v-model="search.keywords"
            clearable
            class="keywords-searcher"
            prefix-icon="el-icon-search"
            :placeholder="$t(`${i18nPrefix}.placeholder.keywordSearch`)"
            @input="handleSearchChange"
          >
          </el-input>
          <el-select
            v-model="search.status"
            clearable
            multiple
            class="status-selector"
            :placeholder="$t(`${i18nPrefix}.placeholder.allStatus`)"
            @change="handleSearchChange"
          >
            <el-option
              v-for="(value, key) in RATE_OPERATE_STATUS"
              :key="key"
              :value="value"
              :label="$t(`${i18nPrefix}.label.${key}`)"
            ></el-option>
          </el-select>
        </div>
      </div>
      <RateTable
        class="rate-table"
        isScrollable
        showCompany
        showJob
        singleActionBtn
        :loading="loading"
        :data="listData"
        :tableColumnWidthMap="tableColumnWidthMap"
        @search="handleSearch"
        @scrollBottom="handleScrollBottom"
        @sendRating="handleSendInviteRating"
        @openCandidateDetail="openCandidateDetail"
      />
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import { RATE_OPERATE_STATUS } from '@/constant/interview'
import RateTable from './components/rateTable.vue'

export default {
  components: {
    RateTable
  },
  props: {
    listData: {
      type: Array,
      required: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    listType: {
      type: String,
      required: false
    },
    search: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      i18nPrefix: 'admin.application.candidate',
      RATE_OPERATE_STATUS,
      emitSearch: null,
      emitScrollBottom: null,
      atBottom: false,
      tableColumnWidthMap: {
        inviteDate: 205,
        companyName: 150,
        jobName: 150,
        recruiter: 138,
        hiringManagerNames: 145,
        candidateNames: 155,
        status: 125,
        action: 120
      }
    }
  },
  computed: {

  },
  created () {

  },
  mounted () {
    this.emitSearch = _.debounce(() => {
      this.$emit('search')
    }, 500)
  },
  methods: {
    handleSearchChange () {
      this.emitSearch && this.emitSearch()
    },
    handleSearch (keywords) {
      this.$emit('search', keywords)
    },
    handleScrollBottom () {
      this.$emit('scrollBottom', this.search)
    },
    handleSendInviteRating (record) {
      this.$emit('sendRating', record)
    },
    openCandidateDetail (rowData) {
      const candidateId = rowData.candidate.id
      const jobId = rowData.job.id
      window.open(`/v-admin/application/profile/screening?candidate_id=${candidateId}&job_id=${jobId}&hidden_bread_crumb=1`)
    }
  },
  watch: {

  }
}
</script>

<style lang="scss" scoped>
.rate-container {
  overflow: hidden;
  display: flex;
  margin-top: 10px;

  .rate-table-container {
    flex: 1;
    display: flex;
    flex-direction: column;
    background-color: #fff;
    padding: 20px 24px;
    overflow: hidden;
    box-shadow: 0px 3px 6px -4px rgba(0,0,0, 0.12);

    .header {
      display: flex;
      align-items: center;
      padding-right: 18px;

      .title {
        color: #303133;
        font-size: 18px;
        font-weight: 500;
        line-height: 25px;
      }

      .search {
        display: flex;
        align-items: center;
        margin-left: auto;

        .keywords-searcher {
          width: 400px;
        }

        .status-selector {
          width: 470px;
          margin-left: 16px;
        }

        ::v-deep .el-input__inner {
          border-radius: 0;
          height: 32px;
          line-height: 32px;

          .el-input__prefix,
          .el-input__suffix {
            .el-input__icon {
              line-height: inherit;
            }
          }

          &:focus {
            border-color: #b2b2b2;
          }

          &:hover {
            border-color: #C0C4CC;
          }
        }
      }
    }

    .rate-table {
      flex: 1;
      border: 0;
      overflow: hidden;
      margin-top: 20px;

      ::v-deep .el-table__header {
        tr {
          th:first-child {
            padding-left: 10px;
          }
        }
      }

      ::v-deep .el-table__body {
        .el-table__row {
          .el-table__cell:first-child {
            padding-left: 10px;
          }
        }
      }

      ::v-deep .el-table__body-wrapper{
        overflow: auto;
      }
    }
  }
}
</style>
